import React, { Component } from 'react';
import { registryCombineReducer as registryCombineReducerFrom } from 'mt-react-common/modules/authUserOutputCash/combines/authUserOutputCashFrom/combineRegistry';
import { registryCombineReducer as registryCombineReducerAccounts } from 'mt-react-common/modules/authUserOutputCash/combines/authUserOutputAccounts/combineRegistry';
import UserOutputCashForm from './UserOutputCashForm';

class StatusesDescTableRWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerNameOutputCashFrom: `authUserOutputCashFrom`,
      reducerNameOutputCashAccounts: `authUserOutputAccounts`
    };
  }

  componentWillMount() {
    registryCombineReducerFrom(this.state.reducerNameOutputCashFrom);
    registryCombineReducerAccounts(this.state.reducerNameOutputCashAccounts);
  }

  render() {
    return (
      <React.Fragment>
        <UserOutputCashForm
          {...this.props}
          reducerNameOutputCashFrom={this.state.reducerNameOutputCashFrom}
          reducerNameOutputCashAccounts={
            this.state.reducerNameOutputCashAccounts
          }
        />
      </React.Fragment>
    );
  }
}

export default StatusesDescTableRWrapper;



// WEBPACK FOOTER //
// ./src/components/UserOutputCash/UserOutputCashForm/index.js